export const BOT_NAME = 'JB';

export const USER_NAME = 'Visitante';
